<template>
  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">

        <div class="bgWight formStyle posRel uploadDocumenti">
          <div class="headForm">
            <div class="row g-3 ">
              <div class="col-md-3 col-6 order-md-1 float-left">
                <img class="logo"
                     src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.webp">
              </div>
              <div class="col-md-3 col-6 order-md-3 float-right imgTitoloDocumento">
                <img src="https://www.rimborsoalvolo.it/cresources/outform/images/dimezzaTempi_small.png">
              </div>
              <div class="col-md-6 col-12 order-md-2">
                <p class="titoloDocumenti"><b>Riduci i tempi di elaborazione 3</b>/3</p>
              </div>

            </div>

          </div>

          <div class="p-4 col-md-12">
            <div class="row g-2">
              <div class="col-md-12 bold600">Eventuali spese conseguenti alla variazione del volo</div>
            </div>
            <div class="row g-2">
              <div class="col-md-12 mb-3">
                            <textarea class="form-control" placeholder="(Es. nuovo volo, pasti, hotel). Le spese possono riguardare esclusivamente: cibo, hotel, volo alternativo. No taxi, no notti perse, no altre spese come biglietti di concerti, parcheggi in aeroporto, ecc." id="acquisti"
                                      style="height: 100px" v-model="acquisti"></textarea>
                <div class="error"></div>
              </div>

            </div>
          </div>

          <div class="p-4 col-md-12 ">
            <div class="col-md-12 mb-3 ">
              <div class="bold600 mb-2">Carica qui eventuali scontrini/ricevute</div>
              <div class="input-group mb-1">

                <file-upload :key="uploadkey" :ticketref="s_ticketref" :psgref="s_psgref" filetype="5"
                             v-model="filecaricato" @uploadcomplete="uploadCompletato($event)"
                             :showimage="false"></file-upload>

              </div>
              <div class="error"></div>
              <div class="txtNote">Dimensioni max: 10MB</div>
            </div>
          </div>

          <div class="p-4 row col-md-12">
            <div class="col-md-12 mb-3 ">
              <p class="bold600" v-if="filecaricati.length < 1">{{ $t('message.nessun_file_caricato') }}</p>
              <table v-if="filecaricati.length > 0" class="tabletable-striped table-bordered">
                <tbody>
                 <tr v-for="file in filecaricati"><td>{{file}}</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="p-4 row g-3 mt-3">
            <div class="col-md-4 order-md-3">
              <button type="submit" class="btn styleBtn mb-3 float-end" @click="submit()">Concludi >
              </button>
            </div>
            <div class="col-md-4 order-md-1">

            </div>
            <div class="col-md-4 order-md-2">

            </div>
          </div>

        </div>

      </div>
    </div>
  </section>

  <trust-pilot></trust-pilot>
  <conteggio-reclami></conteggio-reclami>
  <recensioni-f-b></recensioni-f-b>
  <sezione-a-p-r-a></sezione-a-p-r-a>
  <page-footer></page-footer>
</template>

<script>
import {computed} from "vue";
import {useStore} from "vuex"
import FileUpload from "@/components/FileUpload";
import {submitRiprotezioneBagaglio, submitDescrizioneAcquisti, submitFirmaMandato} from "@/lib/submit";
import useVuelidate from "@vuelidate/core";
import {helpers, requiredIf} from "@vuelidate/validators";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";
const isDate = helpers.withParams(
    {type:'isDate'},
    (value)=>{ if(value === null ){return true; } try{let tdate = moment(value); return tdate.isValid()}catch(e){ return false;}}
);

export default {

name: "RichiedenteStep8",
  setup(){
    const store = useStore();
    const s_ticketref = computed(()=>store.state.compilazione.tktref);
    const s_ticketid = computed(()=>store.state.compilazione.ticketid);
    const s_psgref = computed(()=>store.state.passeggeri.nextpsgref);
    const s_tipodisservizio = computed(()=>store.state.volo.tipoproblema);
    const s_step8_inviato = computed( ()=>store.state.gtmstate.step8inviato);
    return {
      s_psgref,
      s_ticketid,
      s_ticketref,
      s_tipodisservizio,
      v$: useVuelidate(),
      s_step8_inviato,
      setStepCompletato: function(){
        store.dispatch('compilazione/commitSetStepCompletato',6);
      },
      setStep8Inviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvio8',true);
      }
    }
  },
  components:{
    FileUpload,
    Datepicker,
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
  },
  data(){
    return {
      filecaricato: null,
      uploadkey: 1,
      filecaricati: [],
      riprotezionecompagnia : false,
      bagaglioconsegnato : false,
      datariconsegna: null,
      showerrors: false,
      acquisti: '',
    }
  },
  mounted(){
    if(this.s_ticketref === null){
      this.$router.push({name:'step1'});
    }else{
      // eslint-disable-next-line

    }
    window.scrollTo(0,0);
    if(!this.s_step8_inviato) {
      this.setStep8Inviato();
      this.$gtm.trackEvent({
            event: 'step_visitato',
            value: 8,
          }
      );
    }

  },
  methods: {
    uploadCompletato(file) {
      this.filecaricati.push(file);
      this.uploadkey++;
    },
    async submit(){
      let me = this;
      const valid = await this.v$.$validate();
      if(!valid){
        this.showerrors = true;
        return;
      }


      submitFirmaMandato(this.s_ticketref).then((response)=>{
      }).catch((err)=>{ console.log(err);})

      if(me.acquisti !== null && me.acquisti !== ''){
          submitDescrizioneAcquisti(this.s_ticketref,this.acquisti).then((response)=>{
                    me.$router.push({name:'thank1'});
                    me.setStepCompletato();
          }).catch((err)=>{
            console.log(err);
            //non deve essere bloccante
            me.$router.push({name:'thank1'});
            me.setStepCompletato();
          });
      }else {
        me.$router.push({name: 'thank1'});
        me.setStepCompletato();
      }


    }
  },
  validations(){
    return {
      datariprotezione: {  isDate, requiredIf: requiredIf(this.riprotezionecompagnia)},
      datariconsegna: { isDate, requiredIf: requiredIf(this.bagaglioconsegnato  ) },
    }
  },
}
</script>

<style scoped>

</style>